module.exports = __webpack_public_path__ + "img/profess1.03244e8b.png";